import Crud from './crud'
var crud = new Crud('storeexps', 'kho nhận');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Name: '',
        Note: ''
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
